import api from "../../axiosConfig";

export const bookAppointment = async (formData) => {
  const token= sessionStorage.getItem('token');
  try {

    const response = await api.post('appointment/add-appointment', formData);
    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Login error');
  }
};

export const getPatientList = async (search_keyword) => {
    console.log('search keyword:', search_keyword);
    try {
      const response = await api.get('/patient/all-patient', {
        params: {
          search_keyword: search_keyword // 
        }
      });
  
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Error fetching patients');
    }
  };

  export const getAppointments = async (doctor_id,selectedDate,hospital_id) => {
    try {
      const response = await api.get('/appointment/all-appointment',
      {
        params: {
          doctor_id: doctor_id, 
          appointment_date: selectedDate,
          hospital_id: hospital_id 

        },
      });
  
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData?.data };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Error fetching Appointments');
    }
  };

  export const updateAppointment = async (formData) => {  
    // Append required format values

    console.log('Payload for update:', formData);
  
    try {
      const response = await api.post(`/appointment/update-appointment/${formData?.id}`, formData);
  
      const resData = response?.data;
      console.log('Update patient response:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Error updating patients');
    }
  };
  export const deleteAppointment = async (id) => {
  try {
    const response = await api.delete(`appointment/delete/${id}`);

    const resData = response?.data;
    console.log('Delete appointment response:', resData);

    if (resData?.message_type === 'success') {
      return { success: true, data: resData.message };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error deleting medicine');
  }
};

  export const updatePharmacyStatus = async (formData) => {  
    try
    {
      const response = await api.post(`/appointment/update-pharmacy-status/${formData?.id}`, formData);
  
      const resData = response?.data;
      if( resData?.success_type === 'success'|| resData?.message_type === 'success' )
      {
        return { success: true, data: resData };
      }
      else
      {
        return { success: false, error: resData.message };
      }
    }
    catch (err)
    {
      throw new Error(err.response?.data?.message || 'Error updating patients');
    }
  };